var _style, _g, _g2, _g3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavLabelOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.2 47.6",
    style: {
      enableBackground: "new 0 0 39.2 47.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6,43.6V32.9h1.5l3.5,5.5c0.8,1.3,1.4,2.4,1.9,3.5l0,0c-0.1-1.4-0.2-2.8-0.2-4.4v-4.5h1.3v10.8h-1.4l-3.4-5.5 c-0.8-1.2-1.5-2.4-2-3.6l0,0c0.1,1.4,0.1,2.7,0.1,4.5v4.6H6.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9,40.2l-1.1,3.4h-1.4L20,32.9h1.7l3.7,10.8h-1.5l-1.2-3.4H18.9z M22.4,39.2l-1.1-3.1c-0.2-0.7-0.4-1.3-0.6-2h0 c-0.2,0.6-0.3,1.3-0.5,2l-1.1,3.1H22.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5,43.6l-3.5-10.8h1.5l1.7,5.3c0.5,1.5,0.9,2.8,1.2,4h0c0.3-1.2,0.8-2.6,1.2-4l1.8-5.3h1.5L30,43.6H28.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33,26.5L10.1,3.7h17c0.9,0,1.6,0.2,2.1,0.5s1.1,0.9,1.5,1.5l8.4,11.9L33,26.5L33,26.5z M36.8,38.9l-7.7-7.7 c-0.2,0.2-0.5,0.3-0.9,0.4s-0.8,0.1-1.1,0.1H6.2c-0.8,0-1.5-0.3-2.1-0.9s-0.9-1.3-0.9-2.1v-21c0-0.5,0-0.8,0.2-1.1s0.2-0.5,0.3-0.8 L0,2.1L2.1,0l36.8,36.8L36.8,38.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLabelOff);
export default __webpack_public_path__ + "static/media/nav-label-off.5493dea13c0f8b9eaef348846557342b.svg";
export { ForwardRef as ReactComponent };